
import React from 'react';
import ConditionPageTemplate from './ConditionPageTemplate';

const PigmentationSpots = () => {
  const treatments = [
    {
      name: "Laser Facial",
      href: "/treatments/laser-facial",
      description: "Precision targeting of dark spots and pigmentation",
      price: "$450",
      memberPrice: "$349"
    },
    {
      name: "VI Peel",
      href: "/treatments/vi-peel",
      description: "Chemical peel safe for all skin tones",
      price: "$299",
      memberPrice: "$229"
    },
    {
      name: "Ultrasound Facial",
      href: "/treatments/ultrasound-facial",
      description: "Gentle treatment for sensitive or darker skin",
      price: "$350",
      memberPrice: "$269"
    },
    {
      name: "Skin Boosters",
      href: "/treatments/skin-boosters",
      description: "Brightening serums delivered deep into skin",
      price: "$399",
      memberPrice: "$299"
    }
  ];

  return (
    <ConditionPageTemplate
      title="Pigmentation & Spots"
      subtitle="Fade What Doesn't Belong"
      description="Melasma, sunspots, and age-related pigmentation are treated gently with chemical or light-based modalities. Gentle enough for all skin tones, including darker complexions."
      treatments={treatments}
      beforeAfterText="Gradual fading over 4-6 weeks. Safe for all ethnicities and skin types."
    />
  );
};

export default PigmentationSpots;
